export const zhCN = {
  appName: "Regime Job Sheet",
  appSubtitle: "订单与工作流平台",
  language: {
    label: "语言",
    en: "English",
    zhCN: "简体中文",
  },
  shell: {
    navOperations: "运营",
    navInbox: "收件箱",
    navAdministration: "管理",
    navSystem: "系统",
    searchPlaceholder: "搜索订单、单据、客户…",
    searchAria: "打开搜索",
    toggleSidebar: "切换侧栏",
    themeLight: "切换到浅色模式",
    themeDark: "切换到深色模式",
    profileMenu: "个人菜单",
    staffRoleLabel: "Tenant Staff",
    branchLabel: "分行",
  },
  statuses: {
    order: {
      DRAFT: "草稿",
      SUBMITTED: "已提交",
      PROCESSING: "处理中",
      WAITING_CLIENT: "等待客户",
      WAITING_LOGISTICS: "等待物流",
      ON_HOLD: "挂起",
      COMPLETED: "已完成",
      CLOSED: "已关闭",
      CANCELLED: "已取消",
      REJECTED: "已驳回",
    },
    step: {
      PENDING: "待处理",
      IN_PROGRESS: "进行中",
      COMPLETED: "已完成",
      SKIPPED: "已跳过",
      REJECTED: "已驳回",
      WAITING: "等待中",
    },
    approval: {
      PENDING_APPROVAL: "待审批",
      APPROVED: "已通过",
      REJECTED: "已驳回",
      REVISION_REQUESTED: "要求修改",
      RESUBMITTED: "已重新提交",
      CANCELLED: "已取消",
    },
    sla: {
      OK: "正常",
      WARNING: "预警",
      APPROACHING: "即将到期",
      BREACHED: "已违约",
      OVERDUE: "超期",
      ESCALATED: "已升级",
    },
    ticket: {
      OPEN: "待处理",
      PENDING: "处理中",
      WAITING: "等待中",
      RESOLVED: "已解决",
      CLOSED: "已关闭",
    },
  },
  validation: {
    required: "此字段为必填项。",
    invalidEmail: "邮箱地址无效。",
    minLength: "至少需要 {min} 个字符。",
    networkError: "网络错误，请重试。",
    sessionExpired: "会话已过期，请重新登录。",
    somethingWrong: "出了点问题。",
    noPermission: "您没有权限执行此操作。",
  },
  common: {
    save: "保存",
    cancel: "取消",
    create: "创建",
    delete: "删除",
    remove: "移除",
    edit: "编辑",
    search: "搜索",
    noResults: "暂无结果",
    retry: "重试",
    loading: "加载中…",
    pageNotFound: "页面不存在",
    pageNotFoundHint: "您访问的页面不存在。",
    goHome: "返回首页",
    copy: "复制",
    copied: "已复制",
    enabled: "启用",
    disabled: "停用",
    enable: "开启",
    disable: "关闭",
    actions: "操作",
    all: "全部",
    yes: "是",
    no: "否",
    none: "无",
    open: "打开",
    next: "下一步",
    back: "上一步",
    navGroup: "导航",
    prevPage: "上一页",
    nextPage: "下一页",
    pageSummary: "第 {page} / {totalPages} 页 · 共 {total} 条",
    rowsPerPage: "每页行数",
    showingEntries: "显示 {start}–{end}，共 {total} 条",
    noData: "暂无数据",
    selectedCount: "已选 {n} 项",
    searchPlaceholder: "搜索…",
    confirm: "确认",
    loadFailed: "加载失败",
    retryLater: "请稍后重试",
    contactAdminLimit: "已达上限，请联系管理员。",
    device: "设备",
    lastActive: "最近活跃",
    current: "当前",
    other: "其他",
    noSessions: "无会话",
    invitedAt: "邀请时间",
    noInvitations: "暂无邀请",
    actor: "操作人",
    resource: "资源",
    time: "时间",
    provider: "Provider",
    model: "模型",
    openMenu: "打开菜单",
    closeMenu: "关闭菜单",
    close: "关闭",
    goTo: "跳转到…",
    noCommands: "无匹配命令",
  },
  login: {
    title: "登录",
    email: "邮箱",
    password: "密码",
    submit: "登录",
    failed: "登录失败，请检查账号密码",
    unreachable: "无法连接服务，请确认 API 已启动",
    forgot: "忘记密码",
    twoFactorTitle: "两步验证",
    twoFactorHint: "请输入验证器或邮箱中的验证码",
    twoFactorCode: "验证码",
    twoFactorSubmit: "验证并登录",
    twoFactorBack: "返回",
    twoFactorFailed: "验证码无效或已过期",
  },
  forgotPassword: {
    hint: "输入登录邮箱，我们将发送密码重置链接。",
    title: "重置密码",
    submit: "发送重置邮件",
    sent: "邮件已发送",
    back: "返回登录",
  },
  resetPassword: {
    title: "设置新密码",
    newPassword: "新密码",
    confirmPassword: "确认密码",
    mismatch: "两次密码不一致",
    submit: "重置密码",
    ok: "密码重置成功",
    fail: "密码重置失败",
    missingToken: "重置链接缺失或无效。",
  },
  verifyEmail: {
    title: "验证邮箱",
    body: "请查收验证邮件并点击链接完成验证。",
    submit: "验证邮箱",
    done: "邮箱验证成功。",
  },
  acceptInvite: {
    title: "接受邀请",
    password: "密码",
    confirmPassword: "确认密码",
    mismatch: "两次密码不一致",
    submit: "接受邀请",
    ok: "邀请已接受，现在可以登录。",
    fail: "接受邀请失败",
    goLogin: "前往登录",
  },
  twoFactorSetup: {
    title: "设置两步验证",
    body: "用验证器 App 扫描密钥后启用。",
    enable: "启用 2FA",
    disable: "关闭 2FA",
    enabled: "已启用",
    disabled: "未启用",
    scanHint: "扫码或手动输入密钥",
    manualSecret: "手动密钥",
    confirmCode: "验证码",
    confirm: "确认启用",
    passwordConfirm: "关闭前请输入登录密码",
  },
  nav: {
    home: "仪表盘",
    orderServices: "订单服务",
    billingUpload: "账单上传",
    tasks: "任务",
    adminOverview: "概览",
    organizations: "客户企业",
    users: "用户",
    roles: "角色与权限",
    teams: "团队",
    workflows: "工作流",
    tickets: "工单",
    approvals: "审批",
    exceptions: "异常",
    announcements: "公告",
    connections: "连接",
    settings: "设置",
  },
  billingUpload: {
    title: "账单上传",
    description: "查找订单，选择步骤，并上传账单文件。",
    searchLabel: "搜索",
    searchPlaceholder: "运单号、订舱号或集装箱号",
    searchHint: "运单号和订舱号可以输入部分文字。集装箱号必须完整匹配。",
    searching: "搜索中…",
    notFound: "未找到记录",
    notFoundHint: "请换一个运单号、订舱号或集装箱号再试。",
    clearSearch: "清除搜索",
    chooseOrder: "选择订单",
    step: "步骤",
    stepPlaceholder: "选择步骤",
    noSteps: "此订单没有可选步骤。",
    noDocumentTypes: "没有可用的文件类型。",
    documentType: "文件类型",
    documentTypePlaceholder: "选择文件类型",
    files: "文件",
    filesHint: "可以再次选择文件以继续添加。点击上传文件时会一起提交。",
    upload: "上传文件",
    uploading: "上传中…",
    uploaded: "上传成功",
    uploadPartial: "部分文件失败",
    uploadClosed: "此订单已关闭，不能上传文件。",
    fileTooLarge: "文件超过 5 MB。",
    fileType: "不支持此文件类型。",
    filePending: "待上传",
    fileDone: "已上传",
    fileFailed: "失败",
    removeFile: "移除",
    uploadedTitle: "已上传文件",
    uploadedEmpty: "此步骤还没有上传文件。",
    uploadedPickStep: "选择步骤后可查看已上传的文件。",
  },
  dashboard: {
    title: "运营仪表盘",
    description: "一眼掌握新订单、任务、等待客户与 SLA 风险。",
    department: "按部门筛选",
    departmentAll: "全部部门",
    metricNew: "新订单",
    metricInProgress: "进行中",
    metricMyTasks: "我的任务",
    metricTeamTasks: "团队任务",
    metricWaitingClient: "等待客户",
    metricAwaitingDecision: "等待客户决定",
    metricOverdue: "超期",
    metricSlaWarning: "SLA 预警",
    metricCompletedToday: "今日完成",
    viewOrders: "查看订单",
    viewExceptions: "查看异常",
    priorityQueue: "优先任务队列",
    priorityQueueDesc: "已分配及团队工作中风险最高的工作流步骤。",
    statusByDepartment: "部门状态",
    statusByDepartmentDesc: "按当前工作流负责部门汇总进行中的订单。",
    colOrder: "订单编号",
    colClient: "客户 / 客户分行",
    colActiveStep: "当前工作流步骤",
    colStatus: "状态",
    colProgress: "进度",
    noPriorityTasks: "暂无优先任务。",
    noDepartmentStatus: "暂无部门状态。",
    waitingClient: "等待客户",
    slaRisk: "SLA 风险",
    empty: "暂无看板数据",
    emptyDesc: "有新的 Order Service 后会出现在这里",
  },
  exceptions: {
    title: "异常队列",
    description: "SLA 超期、驳回步骤、待审批与到期超期，需优先处理。",
    countSummary: "{total} 条待处理",
    empty: "暂无异常",
    emptyDesc: "超期步骤、驳回与待审批会出现在这里",
    emptyAction: "查看订单列表",
    colSeverity: "严重度",
    colKind: "类型",
    colOrder: "订单",
    colClient: "客户",
    colStep: "步骤",
    colMessage: "说明",
    colAt: "时间",
    actionView: "查看订单",
    severityDanger: "高",
    severityWarning: "中",
    kindSlaOverdue: "SLA 超期",
    kindStepRejected: "步骤驳回",
    kindPendingApproval: "待审批",
    kindDueDateOverdue: "到期超期",
    prevPage: "上一页",
    nextPage: "下一页",
    pageSummary: "第 {page} / {totalPages} 页 · 共 {total} 条",
  },
  tasks: {
    title: "任务",
    description: "跨所有 Order Service 分派给你或你团队的工作流步骤。",
    tabAll: "全部进行中",
    tabMine: "我的任务",
    tabTeam: "团队任务",
    tabOverdue: "超期",
    colOrder: "订单服务",
    colClient: "客户 / 客户分行",
    colStore: "客户分行",
    colStep: "当前步骤",
    colSla: "SLA",
    colAssignee: "负责人",
    empty: "暂无任务",
    emptyDesc: "分派的工作会显示在这里",
    openOrder: "打开订单",
  },
  orderServices: {
    description: "管理订单、负责人、工作流进度与服务异常。",
    title: "订单服务",
    search: "搜索订单编号、客户、货运参考号、订舱号或集装箱号",
    create: "新建订单",
    empty: "暂无订单服务",
    emptyDesc: "创建第一笔 Order Service 开始处理",
    filterAll: "全部",
    filterAssignedToMe: "已分派给我",
    filterClient: "客户方",
    filterStore: "客户分行",
    filterOverdue: "超期",
    filterCompleted: "已完成",
    filterMyTasks: "我的任务",
    filterTeamTasks: "团队任务",
    filterUnassigned: "未分派",
    filterExceptions: "异常",
    colNumber: "编号",
    colService: "服务类型",
    colClient: "客户 / 客户分行",
    colStore: "客户分行",
    colStatus: "状态",
    colStep: "当前步骤",
    colAssignee: "责任人",
    colDue: "到期",
    colProgress: "进度",
    unassigned: "未分派",
    overdue: "超期",
    slaWarning: "SLA 预警",
    clientAction: "需客户操作",
    backToList: "返回列表",
    prevPage: "上一页",
    nextPage: "下一页",
    pageSummary: "第 {page} / {totalPages} 页 · 共 {total} 条",
  },
  orderServiceDetail: {
    title: "订单详情",
    atAGlance: "一眼看懂",
    serviceType: "服务类型",
    clientStore: "客户 / 客户分行",
    status: "状态",
    activeStep: "当前步骤",
    responsible: "责任人",
    missingDocs: "缺失文件",
    completedWork: "已完成工作",
    overdue: "是否超期",
    clientActionNeeded: "是否需要客户操作",
    history: "历史",
    nextAction: "下一步动作",
    nextActionHint: "下一步提示",
    nextActionShow: "展开",
    nextActionHide: "收起",
    branch: "物流分行",
    priority: "优先级",
    references: "参考号",
    workflow: "工作流步骤",
    workflowStepsCount: "{count} 个步骤",
    centerCurrent: "定位当前步骤",
    noMissing: "无缺失文件",
    noCompleted: "尚无已完成步骤",
    noHistory: "暂无历史",
    overview: "概览",
    documents: "文件",
    comments: "评论",
    audit: "审计轨迹",
    billing: "计费",
    access: "访问权限",
    accessBypass: "系统管理员与经理可查看全部订单。",
    accessInheritedStaff: "通过团队责任范围继承",
    accessInheritedClient: "通过客户企业团队终端货主覆盖继承",
    accessGrants: "已授权的用户与团队",
    accessDerived: "通过工作流指派",
    accessDerivedHint: "步骤指派不等于访问授权。",
    accessAddUser: "用户",
    accessAddTeam: "团队",
    accessGrant: "授权",
    accessPrincipalUser: "用户",
    accessPrincipalTeam: "团队",
    accessSourceCreator: "创建者",
    accessSourceExplicit: "已授权",
    commentsEmpty: "暂无评论",
    activityEmpty: "暂无动态",
    commentTimeline: "动态时间线",
    commentAdd: "添加评论",
    commentType: "类型",
    commentScope: "范围",
    commentScopeOrder: "订单服务",
    commentCommented: "发表了评论",
    commentRequestedDocument: "发起了补件请求",
    commentRequestedClose: "发起了关闭申请",
    commentPlaceholder: "输入评论…",
    commentPreset: "预设评论",
    commentPresetPlaceholder: "选择预设以填入正文…",
    commentPresetNone: "暂无预设",
    commentKindComment: "普通评论",
    commentKindDocRequest: "补件请求",
    commentKindCloseRequest: "关闭申请",
    commentInternal: "内部",
    commentInternalHint: "仅租户员工可见 — 不对客户企业显示",
    commentSend: "发送",
    commentSendRequest: "发送补件请求",
    commentSendCloseRequest: "发送关闭申请",
    commentOk: "评论已发送",
    commentFail: "评论失败",
    approvals: "审批",
    approvalsEmpty: "暂无相关审批",
    requestApproval: "发起审批",
    approvalRequested: "已发起审批",
    approvalFail: "审批操作失败",
    noActiveStep: "无进行中步骤",
    noNextAction: "暂无下一步",
    mandatory: "必传",
    optional: "可选",
    unassigned: "未分派",
    progress: "进度",
    summaryClient: "客户企业",
    summaryStore: "客户分行",
    summaryOwner: "创建人",
    exceptionCount: "{count} 个异常",
    documentCount: "{count} 份文件",
    shipmentDetails: "货运信息",
    shipmentVessel: "船名 / 航次",
    shipmentVoyage: "航次",
    shipmentPol: "起运港（POL）",
    shipmentPod: "目的港（POD）",
    shipmentRoute: "起运港 → 目的港",
    shipmentEta: "ETA / ETD",
    shipmentContainers: "集装箱编号",
    containerNumbersTitle: "集装箱号",
    containerOpenCount: "查看 {count} 个",
    containerPastePlaceholder: "从 Excel 粘贴，每行一个，或用逗号分隔。",
    containerValidCount: "{count} 个有效",
    containerInvalid: "不是 11 位集装箱号（4 个字母加 7 个数字）。",
    containerTooMany: "最多 200 个集装箱号。",
    containerFilter: "查找集装箱号",
    containerNoMatch: "没有匹配的集装箱号",
    containerRemove: "移除 {number}",
    shipmentCargo: "货物 / 体积",
    logisticsBranch: "物流分行",
    lastUpdated: "最后更新",
    billingAccount: "计费账户",
    billingRef: "计费参考号",
    actionSubmit: "提交订单",
    actionAdvance: "推进步骤",
    actionHold: "挂起",
    resume: "恢复",
    requestClose: "申请关闭",
    requestCloseOk: "已发送关闭申请",
    moreActions: "更多操作",
    actionComplete: "完成",
    actionClose: "关闭",
    actionCancel: "取消",
    actionReject: "驳回",
    actionAssign: "分配负责人",
    actionAssignStepOwner: "分配步骤负责人",
    assignmentTarget: "步骤",
    actionReopen: "管理员重开",
    reopenReason: "重开原因",
    reopenOk: "已重开",
    reopenFail: "重开失败",
    stepSkip: "跳过步骤",
    stepReopen: "重开步骤",
    stepRepeat: "重复步骤",
    stepReason: "原因",
    stepAdd: "添加步骤",
    stepStart: "开始步骤",
    stepStartNeedsAssignee: "请先分配负责人，再开始此步骤。",
    stepStartOk: "步骤已开始",
    stepEditProperties: "编辑步骤属性",
    stepSlaWarning: "SLA 提醒（分钟）",
    stepPropertiesOk: "步骤属性已保存",
    stepAddName: "步骤名称",
    stepRequired: "必需步骤",
    stepCanSkip: "可跳过",
    stepClientAction: "需要 Client 操作",
    stepClientConsent: "需要客户同意",
    stepApprovalRequired: "需要审批",
    stepSla: "SLA（分钟）",
    stepParallelGroup: "并行组",
    stepParallelGroupNone: "无（按顺序执行）",
    stepParallelGroupNew: "创建新组…",
    stepParallelGroupHint:
      "同一并行组的步骤可同时进行。可选择已有组，或新建简短标识（如 port_regime_bills）。",
    stepParallelGroupNewPlaceholder: "例如 port_regime_bills",
    stepAdvancedShow: "显示高级设置",
    stepAdvancedHide: "隐藏高级设置",
    stepCanReopen: "可重新打开",
    stepCanRepeat: "可重复",
    stepDocumentRequirements: "文件类型要求",
    stepAddOk: "已添加步骤",
    stepRemove: "移除步骤",
    stepRemoveOk: "已移除步骤",
    stepMoveUp: "上移",
    stepMoveDown: "下移",
    stepReorderOk: "顺序已更新",
    checklist: "文件清单",
    checklistEmpty: "暂无清单项",
    checklistAddExtra: "添加 Extra 文件",
    checklistDocType: "文档类型",
    checklistAddOk: "已添加清单项",
    checklistAddFail: "添加失败",
    remarksSave: "保存备注",
    remarksOk: "备注已保存",
    remarksFail: "备注保存失败",
    remarksPlaceholder: "填写备注文字…",
    linkMaster: "关联主文档",
    linkMasterPick: "选择主文档",
    linkMasterOk: "已关联主文档",
    linkMasterFail: "关联失败",
    linkMasterEmpty: "该客户暂无主文档",
    repeatOk: "已添加重复步骤",
    assignMember: "选择员工",
    assignTeam: "选择团队",
    assignDepartment: "选择部门",
    assignType: "分派类型",
    assignTypeUser: "员工",
    assignTypeTeam: "团队",
    assignTypeDepartment: "部门",
    confirmCancel: "确认取消该订单？",
    confirmReject: "确认驳回该订单？",
    actionDone: "操作已完成",
    actionFailed: "操作失败",
    actionEdit: "编辑字段",
    billingReference: "账单参考号",
    editOk: "已保存",
    editFail: "保存失败",
    download: "下载",
    preview: "预览",
    versions: "版本",
    versionsEmpty: "暂无历史版本",
    deleteDoc: "删除文件",
    deleteDocOk: "已删除",
    deleteDocFail: "删除失败",
    recentUploads: "最近上传",
    commentDelete: "删除",
    commentDeleteOk: "评论已删除",
    commentDeleteFail: "删除失败",
    upload: "上传文件",
    takePhoto: "拍照上传",
    chooseFile: "选择文件",
    uploading: "上传中…",
    uploadOk: "上传成功",
    uploadFail: "上传失败，请重试",
    verify: "核验",
    verifyOk: "核验通过",
    verifyFail: "核验失败",
    pendingVerify: "待核验",
    pendingRelease: "待放出",
    releaseDocument: "放出",
    releaseDocumentOk: "已放出给客户",
    releaseDocumentFail: "放出失败",
    releaseNeedsOtherStaff:
      "放出此文件到客户门户需要「放出文件」权限。",
    previewBlocked: "浏览器拦截了预览。请用下载打开文件。",
    returnDocument: "退回",
    returnDocumentTitle: "退回文件",
    returnDocumentReason: "原因",
    returnDocumentOk: "已退回上传人",
    returnDocumentFail: "退回失败",
    rejectDocument: "驳回文件",
    rejectDocumentOk: "已驳回文件",
    rejectDocumentFail: "驳回失败",
    requestClient: "请求客户操作",
  },
  osd: {
    backToList: "返回列表",
    workflowTitle: "工作流",
    workflowSubtitle: "{template} · {count} 个步骤 · 点击步骤查看详情",
    progressSteps: "已完成 {done} / {total} 个必做步骤",
    progressDocs: "必传文件 {done}/{total}",
    progressRef: "参考号 {ref}",
    summaryClient: "客户",
    summaryStore: "客户分行",
    summaryServiceType: "服务类型",
    summaryStatus: "状态",
    summaryBranch: "分行",
    summaryOwner: "负责人",
    summaryActiveStep: "当前步骤",
    summaryResponsible: "责任人",
    nextAction: "下一步",
    documentsTable: "已上传文件",
    documentsColName: "文件",
    documentsColType: "类型",
    documentsColUploader: "上传人",
    documentsColStatus: "状态",
    documentsColDate: "上传时间",
    masterDocs: "主文件库",
    masterDocsEmpty: "该客户暂无主文件",
    auditColTimestamp: "时间",
    auditColUser: "用户",
    auditColAction: "操作",
    auditColResource: "资源",
    auditColIp: "IP",
    billingAccounts: "计费账户",
    billingColName: "账户",
    billingColScope: "范围",
    billingColReference: "外部参考号",
    billingColStatus: "状态",
    billingScopeOrg: "组织级",
    billingScopeStore: "客户分行级",
    stepDrawerApproval: "需审批",
    stepDrawerParallel: "并行组",
    stepDrawerSla: "SLA 目标",
    stepStartedAt: "开始时间",
    stepCompletedAt: "完成时间",
    stepDrawerMinutes: "分钟",
    stepDrawerChecklist: "步骤文件",
    stepDrawerChecklistEmpty: "该步骤无关联文件",
    stepDrawerDocumentsLoading: "正在加载步骤文件…",
    stepDrawerDocumentsError: "无法加载步骤文件",
    stepDrawerStepOf: "第 {step} / {total} 步",
    stepDrawerComments: "步骤评论",
    stepDrawerCommentsEmpty: "该步骤暂无评论",
    stepStatus: "状态",
    stepAssignedTo: "分配给",
    stepDurationSla: "时长与 SLA",
    stepElapsed: "已用时长",
    stepOverdue: "逾期",
    stepApproval: "审批",
    stepApprovalNotRequired: "此步骤无需审批。",
    stepExpectedType: "预期类型",
    stepVerified: "已验证",
    stepUploaded: "已上传",
    stepNotUploaded: "未上传",
    stepCommentsError: "无法加载步骤评论",
    stepCommentPlaceholder: "添加与此步骤相关的评论…",
    bookingNumber: "订舱号 / 提单号",
    notProvided: "未提供",
    overviewSidebar: "订单联系人与提醒",
    clientContact: "客户企业联系人",
    assignedOwner: "已分配负责人",
    exceptionsAlerts: "异常与提醒",
    noClientContact: "暂无客户企业管理员联系人",
    contactUnavailable: "无法加载客户企业联系人",
    noOwner: "尚未分配负责人",
    noAlerts: "暂无提醒",
    holdTitle: "暂停订单服务",
    holdDescription: "此订单服务将暂停，直到恢复处理。",
    uploadTitle: "上传文件",
    uploadWorkflowStep: "工作流步骤",
    uploadDocumentType: "文件类型",
    uploadChecklistItem: "清单项目",
    linkToChecklistItem: "关联到清单项目",
    linkToChecklistHelp: "此文件可以审核，并计入清单完成度。",
    uploadAsExtraHelp: "此文件将作为额外文件上传，不能执行审核。",
    uploadFile: "文件",
    uploadBrowse: "拖放文件或点击选择",
    uploadFormats: "PDF、XLS、XLSX、DOC、DOCX、JPG、PNG · 最大 5 MB",
    noUploadTarget: "暂无可用文件类型",
    noChecklistLink: "未关联清单项目",
    noFileSelected: "尚未选择文件",
    fileTooLarge: "文件超过 5 MB",
    unsupportedFile: "不支持的文件格式",
    uploadNoteLabel: "备注（可选 · 保存为步骤评论）",
    uploadNotePlaceholder: "添加供审核人参考的说明…",
    uploadNoteFailed: "备注未保存",
    uploadStorageUnavailable: "无法连接文件存储。请检查存储项目是否运行，以及是否允许浏览器上传。",
    uploadStorageRejected: "文件存储拒绝了上传",
    requestClientTitle: "请求客户企业操作",
    messageToClient: "发送给客户企业的信息",
    clientRequestPlaceholder: "描述客户企业需要完成的操作…",
    clientRequestEffect: "此请求将关联当前步骤，并可能使订单进入等待客户企业状态。",
    sendClientRequest: "发送请求",
    manageSteps: "管理步骤",
    uploadDocument: "上传文件",
    submitApproval: "提交审批",
  },
  wizard: {
    title: "创建订单服务",
    stepOf: "第 {current} / {total} 步",
    steps: {
      SELECT_PARTIES: "选择相关方",
      SELECT_WORKFLOW_TEMPLATE: "选择工作流模板",
      CUSTOMIZE_WORKFLOW: "自定义工作流与文件",
      ENTER_ORDER_INFO: "填写订单信息",
      REVIEW_AND_SUBMIT: "核对并提交",
    },
    clientOrg: "客户企业",
    clientOrgRequired: "请选择客户企业",
    clientOrgSearch: "搜索客户企业…",
    endCustomer: "终端货主",
    endCustomerRequired: "请选择终端货主",
    endCustomerSearch: "搜索终端货主…",
    workflowTemplate: "工作流模板",
    workflowTemplateRequired: "请选择工作流模板",
    workflowTemplateSearch: "搜索工作流模板…",
    workflowTemplateHint: "服务类型已关联到所选模板。",
    logisticsBranch: "物流分行",
    branchLockedHint: "使用当前登录分行上下文。",
    customerReference: "客户参考号",
    shipmentReference: "货运参考号",
    priority: "优先级",
    remarks: "备注",
    store: "客户分行（可选）",
    storeSearch: "搜索客户分行…",
    storeNone: "不选客户分行",
    storeSkip: "不选客户分行，继续",
    customizeHint:
      "可增减可选步骤与文件清单项。需要时可关联主文件。",
    addStep: "添加步骤",
    addStepName: "步骤名称",
    removeStep: "移除步骤",
    addChecklistItem: "添加清单项",
    removeChecklistItem: "移除",
    documentType: "文件类型",
    documentTypeSearch: "搜索文件类型…",
    mandatory: "必填",
    optional: "可选",
    masterDocuments: "主文件",
    masterDocumentsHint: "从该客户企业选择主文件，关联到本订单服务的文件清单。",
    masterPick: "选择主文件",
    masterSearch: "搜索主文件…",
    masterEmpty: "该客户企业暂无主文件",
    masterLinkToChecklist: "关联到清单项（可选）",
    masterLink: "关联",
    masterLinked: "已关联",
    masterLinkOk: "主文件已关联",
    checklistFromStepHint:
      "来自工作流步骤的文件请在步骤抽屉中编辑。此处仅可删除额外添加的清单项。",
    checklistFromStep: "来自步骤",
    checklistExtra: "额外",
    uploadHint: "可拍照或从相册/文件选择；支持手机相机。",
    reviewTitle: "提交前核对",
    reviewSteps: "工作流步骤",
    reviewStepsAndChecklist: "工作流步骤与文件清单",
    reviewExtraDocuments: "额外文件",
    reviewChecklist: "文件清单",
    reviewMissing: "缺少 {count} 份必填文件",
    reviewServiceType: "服务类型",
    reviewNumber: "单号",
    submit: "提交订单",
    next: "下一步",
    back: "返回",
    submitOk: "已提交",
    submitting: "提交中…",
    createFail: "创建失败，请重试",
    applyFail: "Order Service 已保存为草稿，但部分自定义未能应用，请在详情页继续完成",
    templateLoadFail: "加载 Workflow Template 失败，请重试",
    updateFail: "保存订单信息失败，请重试",
    submitFail: "提交失败，请重试",
    customizeFail: "更新工作流失败，请重试",
    priorityLow: "低",
    priorityNormal: "普通",
    priorityHigh: "高",
    priorityUrgent: "紧急",
    none: "—",
  },
  admin: {
    title: "管理中心",
    description: "配置客户与人员、目录模板、计费参考与合规工具。",
    sectionClientsPeople: "客户与人员",
    sectionCatalogTemplates: "目录与模板",
    sectionFinanceCompliance: "财务与合规",
    users: "用户",
    usersDesc: "Tenant Staff 成员与角色",
    organizations: "客户企业",
    organizationsDesc: "Client Organization 列表",
    stores: "客户分行",
    storesDesc: "客户企业下属客户分行",
    branches: "物流分行",
    branchesDesc: "Logistics Branch（Workspace）",
    workflows: "工作流模板",
    workflowsDesc: "服务类型默认流程",
    documentTypes: "文档类型",
    documentTypesDesc: "单证类型与分类",
    commentPresets: "预设评论",
    commentPresetsDesc: "供租户员工选用的标准回复话术",
    masterDocuments: "主文档库",
    masterDocumentsDesc: "客户企业可复用主文档",
    serviceTypes: "服务类型",
    serviceTypesDesc: "可创建的 Order Service 类型",
    teams: "团队 / 部门",
    teamsDesc: "批量授权用 Team（非 Logistics Branch）",
    billing: "计费账户",
    billingDesc: "客户企业计费参考账户",
    audit: "审计查看",
    auditDesc: "重要操作留痕",
  },
  rolesAdmin: {
    title: "角色与权限",
    description: "系统角色目录与权限矩阵。在「用户」页面为成员分配角色。",
    colRole: "角色",
    colCode: "代码",
    colScope: "范围",
    colPermissions: "权限",
    colSystem: "系统",
    systemYes: "系统",
    systemNo: "自定义",
    assignCta: "为用户分配角色",
    permissionCount: "{n} 项权限",
    empty: "暂无角色",
    emptyDesc: "租户初始化后会出现角色",
    addRole: "新增角色",
    addPermission: "新增权限",
    save: "保存",
    saved: "已保存",
    saveFail: "保存失败",
    delete: "删除",
    deleted: "已删除",
    codePlaceholder: "角色代码，例如 BRANCH_VIEWER",
    namePlaceholder: "角色名称",
    descriptionPlaceholder: "权限说明",
    permissionCatalog: "权限目录",
    permissionDescriptionLabel: "说明",
    noPermissions: "暂无权限",
    systemReadOnly: "系统权限由代码维护，不可在此修改。",
    editRole: "编辑角色",
    roleFormDescription: "设置角色范围并选择允许的系统能力。",
    systemRoleReadOnly: "系统角色由代码维护，仅供查看。",
    basicInformation: "基本资料",
    permissionMatrix: "权限矩阵",
    permissionMatrixHint: "权限按资源分组；勾选后会授予该角色对应能力。",
  },
  teamsAdmin: {
    title: "团队 / 部门",
    description: "用于批量授权与步骤分派，不等于物流分行。",
    create: "新建",
    edit: "编辑",
    save: "保存",
    saved: "已保存",
    saveFail: "保存失败",
    empty: "暂无团队",
    emptyDesc: "创建第一个团队或部门",
    colName: "名称",
    colType: "类型",
    colMembers: "成员数",
    typeTeam: "团队",
    typeDepartment: "部门",
    created: "已创建",
    createFail: "创建失败",
    removed: "已删除",
    removeFail: "删除失败",
    confirmRemove: "确认删除该团队？",
    members: "成员",
    addMember: "添加成员",
    memberUser: "员工",
    memberSearch: "按姓名或邮箱搜索…",
    memberSearchEmpty: "没有匹配的员工",
    memberAdded: "已添加成员",
    memberAddFail: "添加失败",
    memberRemoved: "已移除成员",
    memberRemoveFail: "移除失败",
    membersEmpty: "暂无成员",
    roles: "绑定角色",
    rolesEmpty: "暂无绑定角色",
    addRole: "绑定角色",
    roleAdded: "已绑定角色",
    roleAddFail: "绑定失败",
    roleRemoved: "已移除角色",
    roleRemoveFail: "移除失败",
  },
  billingAdmin: {
    title: "计费账户",
    description: "客户企业计费参考数据（非平台订阅）。",
    create: "新建账户",
    empty: "暂无计费账户",
    emptyDesc: "为客户企业添加计费参考",
    filterOrg: "按客户企业筛选",
    allOrgs: "全部客户企业",
    colName: "名称",
    colOrg: "客户企业",
    colScope: "范围",
    colRef: "外部参考号",
    colStatus: "状态",
    scopeOrg: "企业级",
    scopeStore: "客户分行级",
    store: "客户分行",
    active: "启用",
    inactive: "停用",
    deactivate: "停用",
    confirmDeactivate: "确认停用该账户？",
    created: "已创建",
    createFail: "创建失败",
    deactivated: "已停用",
    deactivateFail: "停用失败",
    edit: "编辑",
    editTitle: "编辑计费账户",
    save: "保存更改",
    updated: "计费账户已更新",
    updateFail: "更新失败",
  },
  approvals: {
    title: "审批收件箱",
    description: "待你处理或与你相关的审批。",
    empty: "暂无审批",
    emptyDesc: "工作流步骤发起审批后会出现在此",
    colOrder: "订单",
    colStatus: "状态",
    colAttempt: "次数",
    colUpdated: "更新时间",
    approve: "通过",
    reject: "驳回",
    rejectReason: "驳回原因",
    approved: "已通过",
    rejected: "已驳回",
    revision: "要求修改",
    resubmit: "重新提交",
    revisionOk: "已要求修改",
    resubmitOk: "已重新提交",
    actionFail: "操作失败",
  },
  clientConsent: {
    title: "客户决定",
    staffDescription: "这些动作在等客户同意或拒绝。员工不能代客户同意。",
    hint: "这只是步骤中的一项动作，不决定步骤能否完成。",
    empty: "暂无客户决定",
    emptyDesc: "许可证与罚金确认会出现在这里。",
    colOrder: "订单",
    colTitle: "动作",
    colDays: "工作日",
    colStatus: "状态",
    statusPending: "等待客户决定",
    statusAgreed: "已同意",
    statusRejected: "已拒绝",
    statusWithdrawn: "已撤回",
    days: "约 {n} 个工作日",
    penalty: "罚金说明",
    summary: "将办理的事项",
    acknowledge: "上述罚金由本公司承担。",
    agree: "同意",
    reject: "拒绝",
    rejectReason: "拒绝理由",
    withdraw: "撤回",
    request: "请求客户决定",
    requestTitle: "动作标题",
    requestSummary: "将办理的事项",
    requestDays: "预计工作日",
    requestPenalty: "罚金说明",
    send: "发给客户",
    sent: "已发送",
    saved: "已保存",
    withdrawn: "已撤回",
    fail: "保存失败",
  },
  organizations: {
    description: "管理企业资料、联系人、终端货主、客户分行与访问权限。",
    title: "客户企业",
    search: "搜索名称或代码",
    empty: "暂无客户企业",
    emptyDesc: "创建第一家 Client Organization",
    create: "新建客户企业",
    edit: "编辑",
    formName: "名称",
    basicInformation: "基本资料",
    corporateIdentity: "企业身份",
    legalName: "法定公司名称",
    tradeName: "商号 / 营运名称",
    registrationNumber: "商业注册号码",
    entityType: "实体类型",
    selectEntityType: "选择实体类型",
    entityPrivateLimited: "私人有限公司（Sdn. Bhd.）",
    entityPublicLimited: "公众有限公司（Bhd.）",
    entityPartnership: "合伙企业",
    entitySoleProprietorship: "独资企业",
    entityLimitedLiabilityPartnership: "有限责任合伙企业",
    selectCountry: "选择国家",
    registeredAddress: "注册地址",
    operationalAddress: "营运地址",
    businessEmail: "业务邮箱",
    supportPhone: "客服联系电话",
    formEngagement: "承接模式",
    engagementDirect: "直客",
    engagementAgent: "代理",
    created: "已创建",
    createFail: "创建失败",
    save: "保存",
    saved: "已保存",
    saveFail: "保存失败",
    deactivate: "停用",
    activate: "启用",
    statusChanged: "状态已更新",
    colName: "名称",
    colCode: "代码",
    colEngagement: "模式",
    colStores: "客户分行数",
    colMembers: "成员数",
    colStatus: "状态",
    statusActive: "启用",
    statusInactive: "停用",
  },
  endCustomers: {
    title: "终端货主",
    description: "管理终端货主及其所属客户分行。",
    empty: "暂无终端货主",
    emptyDesc: "在代理组织下添加终端货主（如 BYD、Proton）",
    create: "新建终端货主",
    edit: "编辑",
    formName: "名称",
    formCode: "代码（可选）",
    created: "已创建",
    createFail: "创建失败",
    save: "保存",
    saved: "已保存",
    saveFail: "保存失败",
    remove: "删除",
    removeOk: "已删除",
    removeFail: "删除失败",
    removeConfirm: "确认删除该终端货主？",
    colName: "名称",
    colCode: "代码",
    colStores: "客户分行数",
    colStatus: "状态",
    statusActive: "启用",
    statusInactive: "停用",
    deactivate: "停用",
    activate: "启用",
  },
  orgMembers: {
    back: "返回客户企业",
    add: "邀请成员",
    empty: "暂无成员",
    emptyDesc: "邀请 Client Admin、Client Staff 或 Client Branch User",
    colName: "姓名",
    colEmail: "邮箱",
    colRole: "角色",
    colEndCustomers: "终端货主",
    roleAdmin: "Client Admin",
    roleStaff: "Client Staff",
    roleStoreUser: "Client Branch User",
    userId: "用户 ID",
    inviteEmail: "邮箱",
    inviteHint: "系统发送邀请链接，受邀人设置密码后加入本企业。",
    inviteOk: "邀请已发送",
    inviteFail: "邀请发送失败",
    invitationsTitle: "邀请",
    invitationsDesc: "已发出、尚未加入的邀请。",
    colStatus: "状态",
    colExpires: "到期",
    statusPending: "待接受",
    statusExpired: "已过期",
    emptyInvitations: "没有未完成的邀请",
    searchUser: "搜索 Client 用户",
    searchUserHint: "至少输入 2 个字符（姓名或邮箱）",
    searchUserEmpty: "没有匹配的 Client 用户",
    pickUser: "选择用户",
    changeRole: "调整角色",
    assignEndCustomers: "分配终端货主",
    assignEndCustomersHint: "代理组织的 Client Staff 至少分配一个",
    assignStores: "分配客户分行",
    addOk: "已添加",
    addFail: "添加失败",
    roleUpdated: "角色已更新",
    roleUpdateFail: "角色更新失败",
    removeOk: "已移除",
    removeFail: "移除失败",
    removeConfirm: "确认移除此成员？",
    notFound: "未找到该客户企业",
  },
  orgTeamResponsibilities: {
    title: "负责团队",
    description:
      "继承该客户企业下全部订单访问权限的员工团队。这不是 RBAC 权限，也不是工作流指派。",
    empty: "暂无负责团队",
    add: "添加团队",
    remove: "移除",
    colTeam: "团队",
    addOk: "已添加责任范围",
    addFail: "添加失败",
    removeOk: "已移除",
    removeFail: "移除失败",
  },
  stores: {
    description: "管理营运地点及其所属组织。",
    title: "客户分行",
    search: "搜索客户分行、代码或客户企业",
    empty: "暂无客户分行",
    emptyDesc: "在客户企业下创建客户分行",
    create: "新建客户分行",
    edit: "编辑",
    formName: "名称",
    formCode: "代码（可选）",
    formAddress: "地址（可选）",
    formOrg: "客户企业",
    formEndCustomer: "终端货主",
    formEndCustomerRequired: "代理组织必须选择终端货主",
    created: "已创建",
    createFail: "创建失败",
    save: "保存",
    saved: "已保存",
    saveFail: "保存失败",
    deactivate: "停用",
    activate: "启用",
    statusChanged: "状态已更新",
    colName: "客户分行",
    colCode: "代码",
    colOrg: "客户企业",
    colEndCustomer: "终端货主",
    colStatus: "状态",
    statusActive: "启用",
    statusInactive: "停用",
  },
  workflows: {
    title: "工作流模板",
    empty: "暂无工作流模板",
    emptyDesc: "为服务类型配置默认步骤",
    create: "新建模板",
    created: "已创建",
    createFail: "创建失败",
    colName: "模板名称",
    colService: "服务类型",
    colSteps: "步骤数",
    colVersion: "版本",
    colStatus: "状态",
    active: "启用",
    inactive: "停用",
    deactivate: "停用",
    activate: "启用",
    statusUpdated: "状态已更新",
    statusFail: "更新失败",
    editSteps: "编辑步骤",
    stepsLabel: "步骤列表",
    stepName: "步骤名称",
    addStep: "添加步骤",
    removeStep: "移除",
    stepsRequired: "至少添加一个步骤",
    stepsSaved: "步骤已保存",
    stepsSaveFail: "步骤保存失败",
    stepRequired: "必选",
  },
  workflowsEditor: {
    title: "工作流模板编辑器",
    subtitle: "为各服务类型配置可复用步骤、SLA、分配与规则。",
    templateOverview: "模板概览",
    templateOverviewDesc: "新建订单服务将继承这些步骤，直至实例被单独调整。",
    templateSettings: "模板设置",
    selectTemplate: "模板",
    newTemplate: "新建模板",
    save: "保存更改",
    saved: "模板已保存",
    saveFail: "保存模板失败",
    created: "模板已创建",
    createFail: "创建模板失败",
    version: "版本",
    templateName: "模板名称",
    serviceType: "服务类型",
    templateActive: "模板启用",
    noServiceType: "无服务类型",
    stepsTitle: "工作流步骤",
    stepCount: "{n} 个步骤",
    addStep: "添加步骤",
    removeStep: "移除步骤",
    moveUp: "上移",
    moveDown: "下移",
    dragToReorder: "拖动排序",
    stepProperties: "步骤属性",
    stepPropertiesDesc: "从该模板生成订单服务时应用的规则。",
    selectStepHint: "选择步骤以编辑属性，或点「模板设置」修改名称与服务类型。",
    stepName: "步骤名称",
    stepRequired: "必选步骤",
    clientActionRequired: "需要客户操作",
    clientConsentRequired: "需要客户同意",
    clientConsentHint: "这是步骤中的一项决定，不阻止完成该步骤。",
    approvalRequired: "需要审批",
    slaExpectedMinutes: "SLA（分钟）",
    slaPlaceholder: "例如 240",
    parallelGroupKey: "并行组键",
    parallelGroupPlaceholder: "可选组标识",
    canSkip: "可跳过",
    canReopen: "可重新打开",
    canRepeat: "可重复",
    slaWarningMinutes: "SLA 预警（分钟）",
    defaultTeam: "默认团队",
    noTeam: "未分配",
    defaultDepartment: "默认部门",
    noDepartment: "未分配",
    defaultAssignee: "默认负责人",
    noAssignee: "未分配",
    dependsOnSteps: "依赖步骤",
    dependsOnNone: "无依赖",
    documentRequirements: "文档类型要求",
    documentRequirementsHint: "勾选本步骤需要的文档类型。",
    docMandatory: "必传",
    duplicate: "复制",
    duplicated: "模板已复制 — 请检查后保存",
    empty: "暂无工作流模板",
    emptyDesc: "创建模板以配置默认工作流步骤。",
    stepsRequired: "至少添加一个已命名步骤",
    loading: "加载模板中…",
    mandatory: "必选",
    optional: "可选",
    clientAction: "客户操作",
    approval: "审批",
    parallel: "并行",
  },
  masterDocuments: {
    title: "主文档库",
    description: "按客户企业维护可复用主文档，订单清单可直接关联。",
    filterOrg: "选择客户企业",
    pickOrg: "请先选择客户企业",
    endCustomer: "终端货主",
    pickEndCustomer: "请选择终端货主",
    empty: "暂无主文档",
    emptyDesc: "上传第一份主文档",
    upload: "上传主文档",
    colName: "文件名",
    colType: "文档类型",
    colVersion: "版本",
    colExpiry: "到期日",
    colCreated: "上传时间",
    colStatus: "状态",
    pendingRelease: "待放出",
    release: "放出",
    releaseOk: "已放出给客户",
    releaseFail: "放出失败",
    return: "退回",
    returnTitle: "退回文件",
    returnReason: "原因",
    returnOk: "已退回上传人",
    returnFail: "退回失败",
    docType: "文档类型",
    issueDate: "签发日期（可选）",
    expiryDate: "到期日期（可选）",
    uploadOk: "上传成功",
    uploadFail: "上传失败",
    download: "下载",
    preview: "预览",
    noExpiry: "无到期日",
    newVersion: "新版本",
    newVersionTitle: "上传新版本",
    newVersionHint: "替换当前文件并递增版本号。",
    newVersionOk: "新版本已上传",
    delete: "删除",
    deleteTitle: "删除主文档",
    deleteConfirm:
      "软删除「{name}」？已关联的订单清单仍保留历史；该文件将移出主文档库。",
    deleteOk: "已删除",
    deleteFail: "删除失败",
  },
  documentTypesAdmin: {
    description: "配置订单与工作流使用的文件要求。",
    title: "文档类型",
    empty: "暂无文档类型",
    emptyDesc: "配置可上传的单证类型",
    create: "新建类型",
    created: "已创建",
    createFail: "创建失败",
    colCode: "代码",
    colName: "名称",
    colCategory: "分类",
    colStatus: "状态",
    active: "启用",
    inactive: "停用",
    deactivate: "停用",
    activate: "启用",
    statusUpdated: "状态已更新",
    statusFail: "更新失败",
    edit: "编辑",
    editTitle: "编辑文档类型",
    save: "保存更改",
    updated: "文档类型已更新",
    updateFail: "更新失败",
    colUiGroup: "UI 分组 / 代码",
  },
  commentPresetsAdmin: {
    title: "预设评论",
    description: "供租户员工在 Order Service 评论时选用的专业标准回复。",
    empty: "暂无预设评论",
    emptyDesc: "添加预设后，员工可快速插入规范回复。",
    create: "新建预设",
    created: "预设评论已创建",
    createFail: "创建预设评论失败",
    colTitle: "标题",
    colBody: "正文",
    colKind: "适用类型",
    colSort: "排序",
    colStatus: "状态",
    kindAny: "全部（评论 / 文件请求）",
    bodyPlaceholder: "填写员工选用后将插入的完整回复内容…",
    active: "启用",
    inactive: "停用",
    deactivate: "停用",
    activate: "启用",
    statusUpdated: "状态已更新",
    statusFail: "更新状态失败",
    edit: "编辑",
    editTitle: "编辑预设评论",
    save: "保存更改",
    updated: "预设评论已更新",
    updateFail: "更新预设评论失败",
    delete: "删除",
    deleted: "预设评论已删除",
    deleteFail: "删除预设评论失败",
  },
  serviceTypesAdmin: {
    description: "配置物流服务及其默认工作流。",
    title: "服务类型",
    empty: "暂无服务类型",
    emptyDesc: "配置可创建的服务与默认模板",
    create: "新建类型",
    created: "已创建",
    createFail: "创建失败",
    colCode: "代码",
    colName: "名称",
    colRunningNumber: "流水编号",
    colTemplate: "默认模板",
    colStatus: "状态",
    active: "启用",
    inactive: "停用",
    noTemplate: "未绑定",
    deactivate: "停用",
    activate: "启用",
    statusUpdated: "状态已更新",
    statusFail: "更新失败",
    edit: "编辑",
    editTitle: "编辑服务类型",
    save: "保存更改",
    updated: "服务类型已更新",
    updateFail: "更新失败",
    templateLabel: "默认工作流模板",
    templateNone: "无模板",
    openWorkflows: "打开工作流",
    runningNumberFormat: "流水编号格式",
    runningNumberHint: "使用 #YY 或 #YYYY、#MM，以及一个如 #5 的序号标记。序号按马来西亚时间每月重置。",
    preview: "预览",
  },
  home: {
    title: "工作台",
    description:
      "物流公司员工门户。Order Service / Workflow / Documents 将在 Plugin 阶段接入。",
    welcomeQuestion: "你主要负责哪类工作？",
    welcomeOps: "运营与客服",
    welcomeOpsDesc: "处理日常工单与客户沟通",
    welcomeAdmin: "系统管理",
    welcomeAdminDesc: "成员、分行与平台配置",
  },
  users: {
    description: "管理租户员工访问、角色与账号状态。",
    title: "用户管理",
    invite: "邀请成员",
    create: "直接创建",
    createTitle: "直接创建用户",
    createName: "姓名",
    createEmail: "邮箱",
    createPassword: "密码",
    createPasswordHint: "至少 10 个字符。对方可使用该密码登录。",
    createBranch: "物流分行",
    allBranches: "全部分行",
    createOk: "用户已创建",
    createFail: "创建用户失败",
    search: "搜索姓名、邮箱或角色",
    empty: "还没有成员",
    emptyDesc: "邀请第一位同事开始协作",
    colName: "姓名",
    colEmail: "邮箱",
    colRole: "角色",
    colBranches: "物流分行",
    colStatus: "状态",
    statusActive: "启用",
    statusInvited: "已邀请",
    statusDisabled: "停用",
    drawerTitle: "成员详情",
    changeRole: "调整角色",
    saveRole: "保存角色",
    roleUpdated: "角色已更新",
    roleUpdateFail: "角色更新失败",
    editBranches: "物流分行",
    saveBranches: "保存分行",
    branchesUpdated: "分行已更新",
    branchesUpdateFail: "分行更新失败",
    passwordResetTitle: "密码重置",
    passwordResetHint:
      "向该租户员工发送一次性重置链接。系统不会显示其当前密码。",
    passwordResetAction: "发送重置邮件",
    passwordResetSent: "重置邮件已发送",
    passwordResetFail: "重置邮件发送失败",
    passwordChangeTitle: "更改员工密码",
    passwordChangeAction: "更改密码",
    passwordChangeWarning:
      "密码将立即更改，并注销该租户员工的所有现有会话。",
    newPassword: "新密码",
    confirmPassword: "确认密码",
    passwordMismatch: "两次密码不一致",
    passwordNeedsLetter: "密码必须包含字母",
    passwordNeedsDigit: "密码必须包含数字",
    passwordChanged: "密码已更改",
    passwordChangeFail: "密码更改失败",
  },
  tickets: {
    description: "查看并处理员工与客户提交的支持请求。",
    title: "工单",
    search: "搜索主题或请求人",
    empty: "暂无工单",
    emptyDesc: "客户提交后会出现在这里",
    colSubject: "主题",
    colStatus: "状态",
    colPriority: "优先级",
    priorityLow: "低",
    priorityNormal: "普通",
    priorityHigh: "高",
    colRequester: "请求人",
    colAssignee: "处理人",
    colUpdated: "更新时间",
    internal: "内部留言",
    public: "对外回复",
    internalHint: "仅员工可见，不会发给 Client",
    publicHint: "Client 可见",
    replyPlaceholder: "输入回复…",
    sendInternal: "发送内部留言",
    sendPublic: "发送对外回复",
    unassigned: "未分配",
    statusLabel: "状态",
    assign: "分派",
    saveAssign: "保存分派",
    assignOk: "分派成功",
    assignFail: "分派失败",
    patchOk: "已更新",
    patchFail: "更新失败",
    create: "新建工单",
    created: "已创建",
    createFail: "创建失败",
    createSubject: "主题",
    createBody: "内容",
    statusOpen: "待处理",
    statusPending: "处理中",
    statusWaiting: "等待中",
    statusResolved: "已解决",
    statusClosed: "已关闭",
    forbidden: "无权限操作此工单",
  },
  announcements: {
    description: "发布并查看面向员工与客户的营运公告。",
    title: "公告",
    inbox: "我的收件箱",
    manage: "管理发布",
    publish: "发布公告",
    edit: "编辑",
    saveDraft: "保存草稿",
    publishOk: "公告已发布",
    publishFail: "公告发布失败",
    unpublish: "取消发布",
    empty: "暂无公告",
    emptyDesc: "发布第一条公告通知员工或客户",
    inboxEmpty: "暂无发给你的公告",
    colTitle: "标题",
    colAudience: "受众",
    colStatus: "状态",
    colPublishedAt: "发布时间",
    formTitle: "标题",
    formBody: "正文",
    formAudience: "受众",
    formStartsAt: "开始时间（可选）",
    formEndsAt: "结束时间（可选）",
    audienceStaff: "仅员工",
    audienceClient: "仅客户",
    audienceBoth: "员工与客户",
    published: "已发布",
    read: "已读",
    unread: "未读",
    markRead: "标为已读",
    formHelper: "让营运更新清晰且可执行。",
    preview: "预览",
    previewEmpty: "公告预览会显示在这里。",
    markdownHint: "支持 Markdown",
    previewMarkdown: "预览 Markdown",
    editMarkdown: "编辑 Markdown",
    inboxDescription: "发送给当前员工账号的有效公告。打开公告后会标记为已读。",
  },
  connections: {
    title: "连接",
    description: "管理已为租户开通的第三方集成。",
    empty: "暂无可用连接",
    emptyDesc: "平台上架并授权后会出现在此",
    all: "全部",
    payment: "支付",
    messaging: "消息",
    logistics: "物流",
    tenantEnabled: "租户启用",
    platformSuspended: "已被平台停用",
    onboarding: "开通状态",
    missing: "待完成项",
    mode: "开通模式",
    create: "新建连接",
    created: "已创建",
    createFail: "创建失败",
    providerCode: "Provider Code",
    displayName: "显示名称",
    category: "类别",
    test: "连通性测试",
    testOk: "测试通过",
    testFail: "测试失败",
  },
  settings: {
    title: "设置",
    description: "组织资料、安全、分行、开发者工具与平台选项。",
    personal: "个人",
    profile: "资料",
    password: "密码",
    security: "两步验证",
    sessions: "活跃会话",
    notifications: "通知偏好",
    org: "组织",
    organization: "基本信息",
    members: "成员",
    invitations: "邀请",
    audit: "审计日志",
    branches: "物流分行",
    verification: "核验",
    developer: "开发者",
    apiKeys: "API Keys",
    webhooks: "Webhooks",
    platform: "平台",
    platformEntitlements: "额度与模块",
    platformModule: "功能模块",
    platformModulesEmpty: "暂无功能模块",
    platformModuleUpdated: "功能模块已更新",
    platformAi: "AI 配置",
    platformAiEmpty: "暂无 AI Provider",
    platformConnectors: "Connector 目录",
    platformRisk: "风险与熔断",
    platformOutOfScope: "管理功能模块、邮件类别及已连接的 AI Provider。",
    emailCategories: "邮件类别",
    emailCategoriesHint:
      "关闭某个类别后，系统停止发送该类邮件。站内通知仍然发送。每个类别还有发送上限，避免同一事项被重复任务刷邮件。",
    emailCategoryLimitText: {
      order_service: "每个完成动作每天 1 封，每个订单状态邮件每天最多 8 封",
      task_assignment: "每个工作流步骤每天最多 3 封，各步骤分开计算",
      document_request: "每个订单每天最多 3 封，各订单分开计算",
      master_document_expiry: "每个客户企业每天一次",
      approval: "每次审批每天一次",
      sla_alert: "每个步骤的每种 SLA 状态每天一次",
      ticketing: "每个工单每天最多 8 封",
      announcement: "每条公告每天一次",
      membership_invite: "每个邮箱每天最多 3 封",
      account_security: "每个邮箱每小时最多 8 封",
      system_error_msg: "每天最多 10 封",
    },
    emailCategoryUpdated: "邮件类别已更新",
    emailCategoryCol: "类别",
    emailCategoryEmail: "邮件",
    emailCategoryLimit: "频率",
    emailCategoryOncePerDay: "每个客户企业每天一次",
    emailCategoryNoLimit: "按事件发送",
    emailCategoryRequired: "登录必需",
    emailCategoriesEmpty: "暂无邮件类别",
    emailCategoryLabel: {
      order_service: "订单服务",
      task_assignment: "任务分配",
      document_request: "单据请求",
      master_document_expiry: "主档到期",
      approval: "审批",
      sla_alert: "SLA 提醒",
      ticketing: "工单",
      announcement: "公告",
      membership_invite: "邀请",
      account_security: "账户安全",
      system_error_msg: "系统错误消息",
    },
    emailCategoryDescription: {
      order_service: "订单创建、完成、关闭、取消或申请关闭。",
      task_assignment: "工作流步骤被分配或改派。",
      document_request: "单据被请求或驳回。",
      master_document_expiry: "主档即将到期。每个客户企业每天一封汇总。",
      approval: "审批请求、通过或驳回。",
      sla_alert: "SLA 临近、超时或升级。",
      ticketing: "工单分配或新消息。",
      announcement: "已发布的公告。",
      membership_invite: "员工与客户企业的邀请邮件。",
      account_security: "重置密码、验证邮箱和登录验证码。",
      system_error_msg: "运行失败通知。",
    },
    auditDelay: "记录可能有数秒延迟",
    auditForbidden: "无权限查看审计日志",
    auditUnavailable: "审计日志列表接口尚未在 API 暴露，页面暂不可用",
    auditSearch: "搜索动作或资源",
    auditAction: "动作",
    auditResourceType: "资源类型",
    auditFrom: "开始时间",
    auditTo: "结束时间",
    auditEmpty: "暂无审计记录",
    auditLoadMore: "下一页",
    auditPrev: "上一页",
    auditPageSummary: "第 {page} 页 · {count} 条记录",
    name: "姓名",
    email: "邮箱",
    mobile: "手机（可选）",
    linkedInfo: "关联信息",
    roles: "角色",
    teams: "团队",
    departments: "部门",
    noneAssigned: "未分配",
    locale: "语言",
    orgName: "组织名称",
    timezone: "时区",
    currentPassword: "当前密码",
    newPassword: "新密码",
    channelInApp: "站内",
    channelEmail: "邮件",
    channelSms: "短信",
    channelPush: "推送",
    typeCol: "通知类型",
    transactionalKeepOne: "此通知为必达类型，请至少保留一个渠道开启。",
    inviteEmail: "邮箱",
    inviteRole: "角色",
    sendInvite: "发送邀请",
    createBranch: "新建分行",
    branchName: "名称",
    branchSlug: "标识",
    addressLine1: "地址第一行",
    addressLine2: "地址第二行（可选）",
    postalCode: "邮政编码",
    city: "城市",
    state: "州属",
    country: "国家",
    phoneNumber: "联系电话",
    archive: "归档",
    branchMembers: "分行成员",
    branchAddMember: "添加成员",
    branchMemberUser: "员工",
    branchMemberRole: "分行角色",
    branchMembersEmpty: "暂无成员",
    branchMemberAdded: "已添加成员",
    branchMemberAddFail: "添加失败",
    branchMemberRemoved: "已移除成员",
    branchMemberRemoveFail: "移除失败",
    branchMemberRoleUpdated: "角色已更新",
    branchMemberRoleFail: "角色更新失败",
    apiKeyName: "名称",
    apiKeyScopes: "权限范围",
    apiKeyScopesHint: "只能勾选你本人已有的权限子集",
    createApiKey: "创建 API Key",
    apiKeyOnce:
      "明文密钥只会显示一次，请立即复制。关闭后无法再查看。",
    revoke: "吊销",
    rotateApiKey: "轮换密钥",
    apiKeyRotated: "密钥已轮换",
    webhookUrl: "回调 URL",
    webhookEvents: "订阅事件",
    addWebhook: "添加 Endpoint",
    editWebhook: "编辑 Endpoint",
    disableWebhook: "停用",
    enableWebhook: "启用",
    confirmDeleteWebhook: "确认删除该 Webhook？",
    webhookSaved: "已保存",
    webhookDeleted: "已删除",
    rotateSecret: "轮换 Secret",
    sendTest: "发送测试事件",
    deliveries: "投递日志",
    replay: "重放",
    webhookEmpty: "暂无 Webhook",
    webhookForbidden: "请用 System Admin 管理",
    webhookTestSent: "测试事件已发送",
    webhookReplayed: "已重放",
    apiKeyEmpty: "暂无 API Key",
    apiKeyForbidden: "请用 System Admin 管理",
    apiKeyRevoked: "已吊销",
    branchEmpty: "暂无分行",
    branchEmptyHint: "请用 System Admin 管理分行",
    requestFailed: "请求失败",
    saved: "已保存",
    passwordUpdated: "密码已更新",
    colStatus: "状态",
    colEvents: "事件",
    colAttempts: "尝试",
    colTime: "时间",
    colCreatedAt: "创建时间",
    colPrefix: "Prefix",
    memberCount: "成员数",
    isDefault: "默认",
    defaultBadge: "默认",
    active: "active",
    disabled: "disabled",
    valid: "有效",
    revokedStatus: "已吊销",
    tripCircuit: "一键熔断",
    circuitOpen: "熔断已开启",
    kycQueue: "Client KYC 审核",
    bpvQueue: "子商家 BPV 审核",
    moduleOff: "模块未开通",
  },
  branch: "物流分行",
  logout: "退出登录",
  notifications: {
    title: "通知",
    empty: "暂无通知",
    markRead: "标为已读",
    ariaLabel: "通知",
  },
} as const;
